import React from 'react';
import { Clock, Calendar } from 'lucide-react';
import Card from '../ui/Card';
import { OPENING_HOURS, BUSINESS_INFO } from '../../utils/constants';

const OpeningHours = () => {
  return (
    <section className="section section-cream">
      <div className="container">
        <div className="section-header">
          <div className="badge">
            <Clock size={16} />
            Service Hours
          </div>
          <h2>When We're Available</h2>
          <p>
            Flexible scheduling to fit your busy lifestyle. Book your valeting service at a time that works for you.
          </p>
        </div>

        <div className="grid grid-2" style={{maxWidth: '1000px', margin: '0 auto'}}>
          <Card hover className="hours-card">
            <div className="hours-icon">
              <Calendar size={32} />
            </div>
            <div className="hours-content">
              <h3>{OPENING_HOURS.weekday.days}</h3>
              <div className="hours-time">{OPENING_HOURS.weekday.hours}</div>
              <p className="hours-description">
                Perfect for after-work valeting or lunchtime service at your office
              </p>
            </div>
          </Card>

          <Card hover className="hours-card">
            <div className="hours-icon weekend">
              <Calendar size={32} />
            </div>
            <div className="hours-content">
              <h3>{OPENING_HOURS.weekend.days}</h3>
              <div className="hours-time">{OPENING_HOURS.weekend.hours}</div>
              <p className="hours-description">
                Weekend slots available for home valeting services
              </p>
            </div>
          </Card>
        </div>

        <div className="text-center mt-4">
          <p style={{color: 'var(--gray-600)'}}>
            Need service outside these hours?{' '}
            <a href={`mailto:${BUSINESS_INFO.email}`} style={{color: 'var(--main-blue)', fontWeight: 600}}>
              Contact us
            </a>{' '}
            for special arrangements
          </p>
        </div>
      </div>
    </section>
  );
};

export default OpeningHours;